const PacksColumns = () => {
    const columns = [
        {
            name: "id",
            label: "id",
            options: {
                filter: false,
                sort: false,
                display: false,
            },
        },
        {
            name: "nom",
            label: "Nom",
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: "preu",
            label: "Preu",
            options: {
                filter: false,
                sort: true,
                sortOrder: "asc",
                customBodyRender: (value) => value + " €",
            },
        },
        {
            name: "escola.nom",
            label: "Escola",
            options: {
                filter: false,
                sort: true,
                sortOrder: "asc",
            },
        },
    ];
    return columns;
};

export default PacksColumns;
